<template>
  <ak-field :label="label" margin-bottom="mb-small" required>
    <ak-select
      v-model="project"
      :options="projects"
      track-by="_id"
      label="title"
      placeholder="Select Project"
      :max-height="100"
      required
    />
  </ak-field>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { request } from '@akerolabs/akero-vue/src/utils/request'

export default defineComponent({
  name: 'AkIntegrationSFTPProject',
  props: {
    service: {
      required: true,
      type: Object,
    },
    label: {
      default: 'Project',
      type: String,
    },
  },
  setup(props) {
    const account = props.service.getAccount()
    const agency = props.service.getAgency()

    /**
     * Operation configuration
     * @type {RefTypes.ComputedRef<*>}
     */
    const operation = props.service.getOperation()

    /**
     * Initialise a list of projects
     * @param fallback
     * @returns {function(): *}
     */
    const initProjects = (fallback) => () =>
      request
        .get(`/campaigns`, {
          params: {
            account,
            agency,
            deleted: JSON.stringify({ $ne: true }),
            filters: 'title',
            per_page: 0,
          },
        })
        .then(
          (response) =>
            (response.data &&
              response.data.status === 'success' &&
              response.data.data) ||
            fallback,
        )

    /**
     * Retrieve projects list
     * @type {RefTypes.ComputedRef<*>}
     */
    const projects = props.service.getServiceData(
      'projects',
      [],
      initProjects([]),
    )

    /**
     * Selected project
     * @type {WritableComputedRef<*>}
     */
    const project = computed({
      get: () =>
        projects.value.find(
          (entry) => entry._id === operation.configuration.campaign,
        ),
      set: (selected) =>
        selected && (operation.configuration.campaign = selected._id),
    })

    return {
      projects,
      project,
    }
  },
})
</script>
